
define('text!templates/widgets/dataGridCells/scheduleReferenceCell.html',[],function () { return '<!-- ko if: href !== \'\' -->\n    <a data-bind="text: label, attr: { href: href }"></a> \n<!-- /ko -->\n<!-- ko if: href === \'\' -->\n    <span data-bind="text: label"></span> \n<!-- /ko -->\n';});

